import {
  tooltip_styles_default
} from "./chunk.X5BY7LOE.js";
import {
  SlTooltip
} from "./chunk.4UVTRU57.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/tooltip/tooltip.ts
var FadvTooltip = class extends SlTooltip {
  constructor() {
    super(...arguments);
    this.variant = "default";
  }
  render() {
    return $`<div class="tooltip-target" aria-describedby="tooltip"><slot></slot></div><div class="tooltip-positioner"><div part="base" id="tooltip" class=${o({
      tooltip: true,
      "tooltip--open": this.open,
      "tooltip--default": this.variant === "default",
      "tooltip--primary": this.variant === "primary",
      "tooltip--secondary": this.variant === "secondary",
      "tooltip--tertiary": this.variant === "tertiary",
      "tooltip--success": this.variant === "success",
      "tooltip--neutral": this.variant === "neutral",
      "tooltip--warning": this.variant === "warning",
      "tooltip--danger": this.variant === "danger"
    })} role="tooltip" aria-hidden=${this.open ? "false" : "true"} ><div part="arrow" class="tooltip__arrow"></div><div part="content" class="tooltip__content" aria-live=${this.open ? "polite" : "off"}><slot name="content">${this.content}</slot></div></div></div>`;
  }
};
FadvTooltip.styles = tooltip_styles_default;
__decorateClass([
  e()
], FadvTooltip.prototype, "variant", 2);
FadvTooltip = __decorateClass([
  n("fadv-tooltip")
], FadvTooltip);

export {
  FadvTooltip
};
